module.exports = __webpack_public_path__ + "static/img/zh-Hans.6c431c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/banners/h5/zh-Hans.png
// module id = 9Ri3
// module chunks = 1